export async function printToBluetoothDevice(order, skuMaster, company) {
    if (!navigator.bluetooth) {
        alert("Bluetooth is not supported on this browser/device.");
        return;
    }

    try {
        const device = await navigator.bluetooth.requestDevice({
            filters: [{ services: ['000018f0-0000-1000-8000-00805f9b34fb'] }], // Standard Bluetooth SPP UUID
            optionalServices: ['000018f0-0000-1000-8000-00805f9b34fb']
        });

        const server = await device.gatt.connect();
        const service = await server.getPrimaryService('000018f0-0000-1000-8000-00805f9b34fb');
        const characteristic = await service.getCharacteristic('00002af1-0000-1000-8000-00805f9b34fb');

        const encoder = new TextEncoder();

        // ESC/POS Commands
        const init = new Uint8Array([0x1b, 0x40]);
        const center = new Uint8Array([0x1b, 0x61, 0x01]);
        const left = new Uint8Array([0x1b, 0x61, 0x00]);
        const boldOn = new Uint8Array([0x1b, 0x45, 0x01]);
        const boldOff = new Uint8Array([0x1b, 0x45, 0x00]);
        const lineFeed = new Uint8Array([0x0a]);

        const send = async (arr) => {
            await characteristic.writeValue(arr);
        };

        const sendText = async (text) => {
            await characteristic.writeValue(encoder.encode(text + "\n"));
        };

        await send(init);
        await send(center);
        await send(boldOn);
        await sendText(company.name || "QUICKBILL");
        await send(boldOff);
        if (company.address1) await sendText(company.address1);
        if (company.phone) await sendText(`Tel: ${company.phone}`);
        if (company.gstin) await sendText(`GSTIN: ${company.gstin}`);
        await sendText("--------------------------------");

        await send(boldOn);
        await sendText("ORDER INVOICE");
        await send(boldOff);
        await send(left);
        await sendText(`Date: ${new Date().toLocaleString()}`);
        await sendText(`Outlet: ${order.outletName}`);
        await sendText(`Beat: ${order.beat}`);
        await sendText("--------------------------------");

        // Items
        await sendText("Item            Qty    Total");
        await sendText("--------------------------------");
        for (const [sku, qty] of Object.entries(order.items || {})) {
            const m = skuMaster[sku] || {};
            const basicEway = Number(m.Basic_Eway) || 0;
            const gstP = Number(m.gst) || 0;
            const mrp = Number(m.mrp) || 0;
            const skuType = (m.skutype || "").toLowerCase();

            let lineBasic = 0;
            let lineTax = 0;

            if (skuType === "tobacco") {
                lineBasic = qty * basicEway;
                const unitBasicRate = mrp / ((100 + gstP) / 100);
                const unitTax = mrp - unitBasicRate;
                lineTax = qty * unitTax;
            } else {
                lineBasic = qty * basicEway;
                lineTax = lineBasic * (gstP / 100);
            }
            const lineTotal = lineBasic + lineTax;

            const name = (m.Name || sku).substring(0, 15).padEnd(16);
            const qtyStr = `${qty}`.padEnd(6);
            const totStr = lineTotal.toFixed(2).padStart(8);
            await sendText(`${name}${qtyStr}${totStr}`);
        }

        await sendText("--------------------------------");
        await sendText(`Basic Total: ${order.totalBasic.toFixed(2).padStart(18)}`);
        await sendText(`CGST Amount: ${order.cgst.toFixed(2).padStart(18)}`);
        await sendText(`SGST Amount: ${order.sgst.toFixed(2).padStart(18)}`);

        // Tax Breakup (Concise for thermal)
        const breakup = {};
        Object.entries(order.items || {}).forEach(([sku, qty]) => {
            const m = skuMaster[sku] || {};
            const gstP = Number(m.gst) || 0;
            const basic = qty * (Number(m.Basic_Eway) || 0);
            const skuType = (m.skutype || "").toLowerCase();
            let tax = 0;
            if (skuType === "tobacco") {
                const mrp = Number(m.mrp) || 0;
                tax = qty * (mrp - (mrp / ((100 + gstP) / 100)));
            } else {
                tax = basic * (gstP / 100);
            }
            if (!breakup[gstP]) breakup[gstP] = { taxable: 0, tax: 0 };
            breakup[gstP].taxable += basic;
            breakup[gstP].tax += tax;
        });

        if (Object.keys(breakup).length > 1) {
            await sendText("-Tax Breakup-");
            for (const [gst, data] of Object.entries(breakup)) {
                await sendText(`${gst}%: T:${data.taxable.toFixed(1)} G:${(data.tax / 2).toFixed(1)}`);
            }
        }

        await send(boldOn);
        await sendText(`GRAND TOTAL: Rs. ${order.totalAmount.toFixed(2).padStart(14)}`);
        await send(boldOff);
        await sendText("--------------------------------");
        await send(center);
        await sendText("Thank you!");
        await send(lineFeed);
        await send(lineFeed);
        await send(lineFeed);

        alert("Print command sent!");
    } catch (err) {
        console.error("Bluetooth Printing Error:", err);
        alert("Failed to print: " + err.message);
    }
}
